import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAosnRudyzqa3YB1RpXQs2Ig94fZ-j_ADc",
  authDomain: "hollas-travel-booking-app.firebaseapp.com",
  projectId: "hollas-travel-booking-app",
  storageBucket: "hollas-travel-booking-app.appspot.com",
  messagingSenderId: "1056128089153",
  appId: "1:1056128089153:web:449603a9fd64bd3d929ac0",
  measurementId: "G-E41XS31HW4"
};

const app = initializeApp(firebaseConfig);
export const database = getAuth(app);